export default __webpack_public_path__ + "assets/trox-logo.781217b10810252ee69e75590512a357.png";